'use strict';

module.exports = (app) => app.factory('dialogService', /* @ngInject */ () => {

    const openDialogs = new Map();
    const dialogData = new Map();
    const dialogUnderlays = new Map();
    const dialogCloseFn = new Map();

    const DEFAULT_DIALOG_CONFIG = {
        region: 'center',
        autofocus: false,
        refocus: false,
        executeScripts: true,
        style: {
            width: '40vw',
            'max-width': '40vw',
            height: '40vw',
            'max-height': '40vw',
        }
    }

    /**
     *
     * @param templatePath {string}
     * @param dialogId {string}
     * @param data - data passed here will be available via getData function
     * @param config {
     *     {title: {string},
     *     region: {string},
     *     autofocus: {boolean},
     *     refocus: {boolean},
     *     executeScripts: {boolean},
     *     style: {
     *         (cssKey: string) multiple
     *     }}
     * }
     * @return {Promise<unknown>}
     */
    function open(templatePath, dialogId, data = {}, config = {}) {
        return new Promise(async resolve => {

            data.config = config;
            dialogData.set(dialogId, data);
            dialogCloseFn.set(dialogId, resolve);
            // resolve promise on dialog close
            config.onHide = () => {
                closeDialog(dialogId);
            }

            config.onLoad = function () {
                compileAngularElement('#' + this.id);

                const dojoDialogUnderlays = document.getElementsByClassName('dijitDialogUnderlay');
                dialogUnderlays.set(dialogId, dojoDialogUnderlays);

                for (let underlay of dojoDialogUnderlays) {
                    underlay.addEventListener('click', () => {
                        closeDialogOnClickOutside(dialogId);
                    })
                }
            }

            openDojoDialog(templatePath, dialogId, config);
        })
    }

    function openDojoDialog(templatePath, dialogId, config) {
        window.getDialogInstance(function (DialogSimple) {

            // merge passed config with default settings
            config = {
                ...DEFAULT_DIALOG_CONFIG,
                ...config
            };

            // generate css string out of config styles
            let style = '';
            for (let key of Object.getOwnPropertyNames(config.style)) {
                style += `${key}: ${config.style[key]};`;
            }

            const dojoDialogConfig = {
                ...config,
                style,
                href: templatePath
            };

            const dialogRef = new DialogSimple(dojoDialogConfig);

            dialogRef.startup();
            dialogRef.show();

            openDialogs.set(dialogId, dialogRef);
        })
    }

    function closeDialogOnClickOutside(dialogId) {
        const underlays = dialogUnderlays.get(dialogId);
        if (underlays) {
            for (let underlay of underlays) {
                underlay.removeEventListener('click', closeDialog);
            }
        }

        closeDialog(dialogId);
    }

    function getData(dialogId) {
        return dialogData.get(dialogId);
    }

    function closeDialog(dialogId, data = null) {
        const dialogRef = openDialogs.get(dialogId);
        if (dialogRef) {
            const closeFn = dialogCloseFn.get(dialogId);
            if (closeFn) {
                closeFn(data);
            }

            dialogData.delete(dialogId);
            openDialogs.delete(dialogId);
            dialogCloseFn.delete(dialogId);
            dialogUnderlays.delete(dialogId);

            dialogRef.open = false;
            dialogRef.destroyRecursive();
        }
    }

    function getDialogRef(dialogId) {
        return openDialogs.get(dialogId);
    }

    return {
        open,
        getData,
        closeDialog,
        getDialogRef,
    }
});
